import type React from "react";
import { useDispatch } from "react-redux";
import { AssetsService } from "app/services/AssetsService";
import { i18nFilter } from "app/filters/i18nFilter";
import { EmptyStateContainer } from "app/pages/digital-suite/home-page/components/CustomAssets/Containers/EmptyStateContainer/EmptyStateContainer";
import type { IEmptyStateProps } from "app/pages/digital-suite/home-page/components/CustomAssets/types";
import { AssetName } from "app/pages/digital-suite/home-page/components/CustomAssets/types";
import {
    navigateToDashboardsTemplatesGallery,
    navigateToDashboardsDailyTrafficAnalysisTemplate,
    navigateToDashboardsKeywordsOptimizationTemplate,
} from "app/pages/digital-suite/home-page/components/CustomAssets/customAssetsUtils";
import { DashboardTrackerTooltipContent } from "app/pages/digital-suite/home-page/components/CustomAssets/AssetsTooltipContent/DashboardTooltipContent";
import { allTrackers } from "app/services/track/track";

export const DashboardsEmptyState: React.FC<IEmptyStateProps> = ({ userWebsite }) => {
    const i18n = i18nFilter();
    const dispatch = useDispatch();

    return (
        <EmptyStateContainer
            type={AssetName.Dashboard}
            title={i18n("digitalmarketing.homepage.custom_assets.empty_state.dashboards.title")}
            subtitle={i18n("digitalmarketing.homepage.custom_assets.empty_state.dashboards.subtitle")}
            genericTemplateProps={{
                iconName: "arrow-right",
                text: i18n("digitalmarketing.homepage.custom_assets.empty_state.dashboards.free_creation_text"),
                onClick: () => {
                    allTrackers.dispatchTrackEvent(
                        "Button",
                        "click",
                        "My Assets/Create a dashboard/Click on more templates",
                    );
                    navigateToDashboardsTemplatesGallery();
                },
            }}
            columns={3}
            assets={[
                {
                    title: i18n(
                        "digitalmarketing.homepage.custom_assets.empty_state.dashboards.templates.daily_traffic.title",
                    ),
                    content: (
                        <img
                            src={AssetsService.assetUrl("/images/custom-assets/daily-traffic-analysis.svg")}
                            alt={""}
                        />
                    ),
                    buttonText: i18n(
                        "digitalmarketing.homepage.custom_assets.empty_state.dashboards.templates.daily_traffic.button",
                    ),
                    hoverText: i18n(
                        "digitalmarketing.homepage.custom_assets.empty_state.dashboards.templates.daily_traffic.text",
                    ),
                    onClick: () => navigateToDashboardsDailyTrafficAnalysisTemplate(dispatch, userWebsite),
                },
                {
                    title: i18n(
                        "digitalmarketing.homepage.custom_assets.empty_state.dashboards.templates.keywords.title",
                    ),
                    content: (
                        <img
                            src={AssetsService.assetUrl("/images/custom-assets/keywords-optimization.svg")}
                            alt={""}
                        />
                    ),
                    buttonText: i18n(
                        "digitalmarketing.homepage.custom_assets.empty_state.dashboards.templates.keywords.button",
                    ),
                    hoverText: i18n(
                        "digitalmarketing.homepage.custom_assets.empty_state.dashboards.templates.keywords.text",
                    ),
                    onClick: () => navigateToDashboardsKeywordsOptimizationTemplate(dispatch, userWebsite),
                },
            ]}
            infoTooltipContent={<DashboardTrackerTooltipContent />}
        />
    );
};
